module.exports = __webpack_public_path__ + "static/media/annaluke_engagement-103-min.c8a9103f.jpg";